import styled from "styled-components";

export const TableHeaderContent = styled.div`  
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  .headerTitle{
    width: 595px;
    padding-bottom: 10px;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #BEBEBE;
    
    span{
      color: #858585;
      font-size: 12px;
    }
  }
`;